
<template>
	<div :class="columnClass">
        <div v-if="columnLabel=='employee_name'" class="table-td-border-right th_cell_1">
            <div class="calls-table-cell-inner-table o-modal-trigger" data-toggle="modal" data-target="#employeeSummaryModal">

                <div class="o-accordion-subtext o-rowtable-text">
                    <!-- <div>{{(selectedSortType=='fname_asc')?employee.first_name+" "+employee.last_name : employee.last_name+", "+employee.first_name}}</div> -->
                    <div>
                      {{ employee.employable?employee.employable.last_name+", "+employee.employable.first_name:'' }}
                    </div>

                </div>
            </div>
        </div>

        <div v-if="columnLabel=='employee_seniority'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{ getRoundOffSkillSeniority(employee.seniority) || 0 }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='skill_seniority'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{ getRoundOffSkillSeniority(employee.skill_seniority) || 0 }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='shift_count_ytd'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.total_shift_YTD || '0' }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='shift_count_total'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.total_shifts || '0' }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='shifts_this_week'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.total_shift_weekly || '0' }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='shifts_ytd_july_june'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.total_decline_july_june || '0' }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='declines_total'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.total_decline || '0' }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='declines_ytd'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.total_decline_YTD || '0' }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='declines_ytd_july_june'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.total_decline_july_june || '0' }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='decline_this_week'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.total_decline_weekly || '0' }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='participation'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{getParticipation(employee.participation)}} %</div>
            </div>
        </div>

        <div v-if="columnLabel=='participation_july_june_desc'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{getParticipationJulyJune(employee.participation_july_june)}} %</div>
            </div>
        </div>

        <div v-if="columnLabel=='last_offer'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.last_offer ? getGloabalDateTimeFormat(employee.last_offer) : ""}}</div>
            </div>
        </div>

        <div v-if="columnLabel=='last_assigned'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.last_assigned ? getGloabalDateTimeFormat(employee.last_assigned) : ""}}</div>
            </div>
        </div>

        <div v-if="columnLabel=='last_confirmed'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.last_confirmed ? getGloabalDateTimeFormat(employee.last_confirmed) : ""}}</div>
            </div>
        </div>

        <div v-if="columnLabel=='location'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.address || '- - -'}}</div>
                <!-- <div>Add Location</div> -->
            </div>
        </div>

        <div v-if="columnLabel=='wishlist'" class="table-td-border-right calls-table-cell-inner-table">
            <div class="o-accordion-subtext o-rowtable-text">
                <span v-if="employee.wishlist&&employee.wishlist.length">
                    Wishlist:
                    <el-tooltip v-if="employee.wishlist&&employee.wishlist.length&&employee.wishlist[0].employee_message" class="item" effect="light" :content="employee.wishlist[0].employee_message" placement="top-end">
                        <i :class="(employee.wishlist.length==0)?'fa fa-star fa-star--disable':((employee.wishlist[0].type !='W') ? 'fa fa-ban' : 'fa fa-star')" aria-hidden="true"></i>
                    </el-tooltip>
                    <i v-else-if="employee.wishlist&&employee.wishlist.length" :class="(employee.wishlist.length==0)?'fa fa-star fa-star--disable':((employee.wishlist[0].type !='W')? 'fa fa-ban' : 'fa fa-star')" aria-hidden="true"></i>
                </span>
                <span v-else></span>
                <div>{{(employee && employee.wishlist.length)? getTimeStampValue(employee.wishlist[0].wishlist_timing):''}}</div>
            </div>
        </div>


        <div v-if="columnLabel=='custom_field1'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{getCustomField(employee.custom_field1)}}</div>
            </div>
        </div>

        <div v-if="columnLabel=='custom_field2'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{getCustomField(employee.custom_field2)}}</div>
            </div>
        </div>

        <div v-if="columnLabel=='employee_cell_phone'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <!-- <div>{{(employee.employable.phones && employee.employable.phones.length>0)? employee.employable.phones[0].phone_number :'--' }}</div> -->
                    <div>
                        <!-- {{employee.phone_number || '- - -'}} -->
                        <a v-if="employee.employable&&employee.employable.get_cell_phone&&employee.employable.get_cell_phone.phone_number" :href="'tel:'+getClientContactFormat(employee.employable.get_cell_phone.phone_number)" class="phone-number-display">
                            {{ employee.employable.get_cell_phone&&employee.employable.get_cell_phone.phone_number ? getClientContactFormat(employee.employable.get_cell_phone.phone_number) : '' }}
                        </a>
                        <span v-else>NA</span>
                    </div>
            </div>
        </div>

        <div v-if="columnLabel=='conflicts'">
            <!-- #1602 — HTS colour precedence: a committed HTS hold (blue = this
                 job / orange = another) holds the worker through strike, so it
                 OVERRIDES the red vacation conflict. Suppress the vacation block
                 for HTS-held workers; non-HTS workers still show it (per-day). -->
            <div v-if="(employee.employable&&employee.employable.vacations&&employee.employable.vacations.length) && !(employee.hts && Object.keys(employee.hts).length>0)" class="table-td-border-right calls-table-cell-inner-table m-2">
                <!-- <div class="o-tags u-no-padding text-right o-tag-btn-container">
                    <ul class="o-tag-btn-area o-float-right">
                        <li class="o-half-div">
                            <a href="javascript: void(0)" class="c-tag-btn u-btn-red">
                                {{ checkVacationWithinCall(employee.employable.vacations)
                                ?
                                'Unavailable due to vacation'
                                :
                                'Unavailable due to vacation' }}
                            </a>
                        </li>
                    </ul>
                </div> -->
                <div v-html="renderVacations(employee.employable.vacations)"></div>
            </div>

            <div class="table-td-border-right calls-table-cell-inner-table m-2" v-if="employee.employable && employee.employable.availibility && employee.employable.availibility.available_times">
                <div class="o-tags u-no-padding text-right o-tag-btn-container">
                    <div v-html="renderUnavailability(employee.employable.availibility.available_times)"></div>
                </div>
            </div>

            <!-- <div v-if="employee.calls&&employee.calls.length" class="table-td-border-right calls-table-cell-inner-table"> -->
            <div v-if="employee.calls&&employee.calls.length" class="">
                <div v-for="(call,index) in employee.calls" :key="index" class="">
                     <div class="u-no-padding text-right o-tag-btn-container">
                        <!-- <a href="javascript: void(0)" class="c-tag-btn u-btn-blue"> -->
                        <a href="javascript: void(0)" class="o-half-div c-tag-btn" :class="getClassNameForCallActionTypes(call)">
                            <span v-if="call.call_actions&&call.call_actions.length&&call.call_actions[0].status&&call.call_actions[0].status.name">{{ call.call_actions[0].status.name+': ' }}</span>
                            <span><b>{{ call.job&&call.job.title?call.job.title+' - ':'Job Name - ' }}</b></span>
                            <span v-if="call.call_actions&&call.call_actions.length&&call.call_actions[0].status&&call.call_actions[0].status.name&&(call.call_actions[0].status.name=='Declined'||call.call_actions[0].status.name=='Call Out')">{{ getFullTimeFormat(call.call_actions[0].created_at) }}</span>
                            <span class="mr-2" v-else>{{ getCallTime(call.start) + '-' +getCallTime(call.end)}}</span>
                            <br />
                            <span v-if="(call.call_actions&&call.call_actions.length&&call.call_actions[0].action_log&&call.call_actions[0].action_log.note&&call.call_actions[0].action_log.note.content) && (call.call_actions[0].status.name == 'Declined' || call.call_actions[0].status.name == 'Call Out')">
                                {{ ' - ' + getCallActionNote(call.call_actions[0].action_log.note.content) }}
                            </span>
                        </a>
                    </div>
                </div>
            </div>

            <!-- <div v-if="employee.call_actions&&employee.call_actions.length" class="table-td-border-right calls-table-cell-inner-table"> -->
            <div v-if="employee.call_actions&&employee.call_actions.length" class="">
                <div v-for="(action,index) in employee.call_actions" :key="index" class="">
                        <!-- <br v-if="index%3==0" /> -->
                     <div class="u-no-padding text-right o-tag-btn-container">
                        <!-- <a href="javascript: void(0)" class="c-tag-btn u-btn-blue"> -->
                        <a href="javascript: void(0)" class="c-tag-btn" :class="getClassNameForCallActionTypes2(action)">
                            <span v-if="action.action_log&&action.action_log.status&&action.action_log.status.name">{{ action.action_log.status.name+': ' }}</span>
                            <span><b>{{ action.action_log&&action.action_log.job&&action.action_log.job.title?action.action_log.job.title+' - ':'Job Name - ' }}</b></span>
                            <span v-if="action.action_log&&action.action_log.status&&action.action_log.status.name&&(action.action_log.status.name=='Sent Home' || action.action_log.status.name=='Declined' || action.action_log.status.name=='Call Out' || action.action_log.status.name=='No-show')">{{ getFullTimeFormat(action.action_log.created_at) }}</span>
                            <span v-else>{{ getCallTime(action.action_log.start) + ' - ' +getCallTime(action.action_log.end) }}</span>
                            <!-- <span class="mr-2" v-else>{{ getCallTime(call.start) + '-' +getCallTime(call.end)}}</span> -->
                            <br />
                            <span v-if="(action.action_log&&action.action_log.note&&action.action_log.note.content) && (action.action_log.status.name == 'Sent Home' || action.action_log.status.name == 'Declined' || action.action_log.status.name == 'Call Out')">
                                {{ ' - ' + getCallActionNote(action.action_log.note.content) }}
                            </span>
                        </a>
                    </div>
                </div>
            </div>

            <div v-if="checkAvailability(employee)" class="table-td-border-right calls-table-cell-inner-table">
                <div class="o-tags u-no-padding text-right o-tag-btn-container">
                     <li class="o-half-div c-tag-btn u-btn-green">
                        <a href="javascript: void(0)">
                            <span class="text-dark">Available</span>
                        </a>
                    </li>
                </div>
            </div>

            <!-- <div v-if="employee.bookings&&employee.bookings.length == 0 && !getDeclineStatus(employee.call_actions) && !getPassStatus(employee.call_actions) && !getTimeOutStatus(employee.call_actions) && !getCallOutStatus(employee.call_actions)" class="table-td-border-right calls-table-cell-inner-table">

                <div class="o-tags u-no-padding text-right o-tag-btn-container">
                    <ul v-if="!getDeclineStatus(employee.call_actions) && !getPassStatus(employee.call_actions)" class="o-tag-btn-area o-float-right">

                        <li v-if="!employee.previous_calls" :class="{'o-half-div': true, 'o-half-div-width': !isCurrentJobHTS(employee.hts)}">
                            <a href="javascript: void(0)" :class="{'c-tag-btn u-btn-blue':(Object.keys(employee.hts).length>0 && isCurrentJobHTS(employee.hts)), 'c-tag-btn u-btn-light-orange':employee.hts&&(Object.keys(employee.hts).length>0 && !isCurrentJobHTS(employee.hts)), 'c-tag-btn u-btn-green':(Object.keys(employee.hts).length==0)}">Available</a>
                        </li>

                        <li v-if="employee.previous_calls&&Object.keys(employee.previous_calls).length!=0" :class="{'o-half-div': true, 'o-half-div-width': !isCurrentJobHTS(employee.hts)}">
                            <a href="javascript: void(0)" :class="{'c-tag-btn u-btn-blue':(employee.hts&&Object.keys(employee.hts).length>0 && isCurrentJobHTS(employee.hts)), 'c-tag-btn u-btn-light-orange':(employee.hts&&Object.keys(employee.hts).length>0 && !isCurrentJobHTS(employee.hts)), 'c-tag-btn u-btn-green':(Object.keys(employee.hts).length==0 && !checkTurnOver(employee.previous_calls)), 'c-tag-btn u-btn-yellow':(employee.hts&&Object.keys(employee.hts).length==0 && checkTurnOver(employee.previous_calls)),'u-btn-border-red':checkPrevNextCallSameDay(employee.prev_Call, employee.prev_Call_job_id)}">
                                {{ getPrevCallTime(employee.previous_calls) }}
                            </a>
                        </li>

                        <li v-if="employee.hts && employee.hts&&Object.keys(employee.hts).length>0 && !isCurrentJobHTS(employee.hts)" class="o-half-div o-half-div-width">
                            <a href="javascript: void(0)" class="c-tag-btn u-btn-light-orange">{{getJobTitle(employee.hts)}}</a>
                        </li>

                        <li v-if="!employee.next_calls" :class="{'o-half-div':  true, 'o-half-div-width': !isCurrentJobHTS(employee.hts)}">
                            <a href="javascript: void(0)" :class="{'c-tag-btn u-btn-blue':employee.hts&&(Object.keys(employee.hts).length>0 && employee.hts&&isCurrentJobHTS(employee.hts)), 'c-tag-btn u-btn-light-orange':(Object.keys(employee.hts).length>0 && !isCurrentJobHTS(employee.hts)), 'c-tag-btn u-btn-green':(Object.keys(employee.hts).length==0),'c-tag-btn u-btn-yellow1':(employee.next_vacation&&employee.next_vacation.length&&employee.next_vacation[0].vacation_interval)}">
                                <span v-if="employee.next_vacation&&employee.next_vacation.length&&employee.next_vacation[0].vacation_interval">
                                    {{getNextVacationTime(employee.next_vacation)}}
                                </span>
                                <span v-else>Available</span>
                            </a>
                        </li>

                        <li v-if="employee.next_calls&&Object.keys(employee.next_calls).length!=0" :class="{'o-half-div':  true, 'o-half-div-width': !isCurrentJobHTS(employee.hts)}">
                            <a href="javascript: void(0)" :class="{'c-tag-btn u-btn-blue':employee.hts&&(Object.keys(employee.hts).length>0 && isCurrentJobHTS(employee.hts)),'c-tag-btn u-btn-light-orange':(employee.hts&&Object.keys(employee.hts).length>0 && !isCurrentJobHTS(employee.hts)),'c-tag-btn u-btn-green':(Object.keys(employee.hts).length==0 && (!employee.next_calls||!checkTurnOver(employee.next_calls))),'c-tag-btn u-btn-yellow':(!employee.hts||Object.keys(employee.hts).length==0 && employee.next_calls&&checkTurnOver(employee.next_calls)),'c-tag-btn u-btn-yellow1':(employee.next_vacation&&employee.next_vacation.length&&employee.next_vacation[0].vacation_interval),'u-btn-border-red':checkPrevNextCallSameDay(employee.next_Call, employee.next_Call_job_id)}">
                                <span v-if="employee.next_vacation&&employee.next_vacation.length&&employee.next_vacation[0].vacation_interval">

                                    {{ employee.next_calls?getNextCallTime(employee.next_calls):'' }} <br />
                                    {{ employee.next_vacation?getNextVacationTime(employee.next_vacation):'' }}
                                </span>
                                <span v-else>{{ employee.next_calls?getNextCallTime(employee.next_calls):'' }} </span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <div v-if="employee.bookings&&employee.bookings.length>0" class="table-td-border-right calls-table-cell-inner-table">
                <div class="o-tags u-no-padding text-right o-tag-btn-container">
                    <ul class="o-tag-btn-area o-float-right">
                        <li class="o-half-div" v-if="!checkAssignedJob(employee)">
                            <a href="javascript: void(0)" :class="employee.bookings&&checkThisClickCooking(employee.bookings)?'c-tag-btn u-btn-orange':'c-tag-btn u-btn-red'">
                            {{employee.bookings&&checkThisClickCooking(employee.bookings)?employee.bookings[0].job_name+ ':' +getConflictDate(employee.bookings[0].start)+'('+getTime(employee.bookings[0].start) +'-'+ getTime(employee.bookings[0].end)+')':'OTHER BOOKING'}}
                            </a>
                        </li>

                        <li class="o-half-div" v-else>
                            <a href="javascript: void(0)" class="c-tag-btn u-btn-blue" >
                            {{ employee.bookings&&employee.bookings.length?employee.bookings[0].job_name+ ':' +getConflictDate(employee.bookings[0].start)+'('+getTime(employee.bookings[0].start) +'-'+ getTime(employee.bookings[0].end)+')':''}}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>  -->

            <!-- <div class="table-td-border-right calls-table-cell-inner-table">
                <div class="o-tags u-no-padding text-right o-tag-btn-container">
                    <ul v-if="getDeclineStatus(employee.call_actions)" class="o-tag-btn-area o-float-right">
                        <li class="o-half-div" @click="openDeclinedModal(employee)"><a href="javascript: void(0)" class="c-tag-btn u-btn-red">Declined : {{getCallActionByType(employee.call_actions, "Declined")[0].job_name}}</a></li>
                    </ul>

                    <ul v-else-if="!getDeclineStatus(employee.call_actions) && getCallOutStatus(employee.call_actions) && !getTimeOutStatus(employee.call_actions)" class="o-tag-btn-area o-float-right">
                        <li class="o-half-div"><a href="javascript: void(0)" class="c-tag-btn u-btn-yellow">Called Out : {{getCallActionByType(employee.call_actions, "Call Out")[0].job_name}}</a></li>
                    </ul>
                    <ul v-else-if="!getDeclineStatus(employee.call_actions) && getTimeOutStatus(employee.call_actions) && !getPassStatus(employee.call_actions)" class="o-tag-btn-area o-float-right">
                        <li class="o-half-div"><a href="javascript: void(0)" class="c-tag-btn u-btn-yellow">Timed Out : {{getCallActionByType(employee.call_actions, "Timed Out")[0].job_name}}</a></li>
                    </ul>
                    <ul v-else-if="!getDeclineStatus(employee.call_actions) && getPassStatus(employee.call_actions)" class="o-tag-btn-area o-float-right">
                        <li class="o-half-div"><a href="javascript: void(0)" class="c-tag-btn u-btn-yellow">Passed : {{getCallActionByType(employee.call_actions, "Passed")[0].job_name}}</a></li>
                    </ul>
                </div>
            </div> -->
        </div>
	</div>
</template>

<script>
    import dateTimeConvert from '../../../timeConvert&Compare';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import {
        global
    } from '../../../global.js';
    import { bus } from '../../../main';
    import service from '../../../services.js';
    export default {
        props: {
            isSteward: {
                type: Number,
                required: true
            },
            employee: {
                type: Object,
                required: true
            },
            columnLabel: {
                type: String,
                required: true
            },
            client:{
                type: Object,
                required: true
            },
            selectedSortType:{
                type: String,
                required: true
            },
            userDateFormat: {
                type:String,
                required: false
            },
            userTimeFormat: {
                type:String,
                required: false
            },
            date: {
                type: String,
                required: false,
                default: moment().format('YYYY-MM-DD HH:mm:ss')
            }
        },
        data() {
            return {
                noRecurring: false,
                columnClass:'',
                turnoverTime: '',
                customField1: '',
                customField2: '',
                showCustom: '',
                address:'',
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                userID: 'userID',
                userRoleSlug: 'userRoleSlug',
                employeeId: "employeeId",
                // bulkCallStartTime: 'bulkCallStartTime',
                bulkCallEndTime: 'bulkCallEndTime'
            })
        },
        methods: {
            getFullTimeFormat(time) {
                return moment(time).format('MM/DD/YYYY hh:mm A');
            },
            getClassNameForCallActionTypes(call){
                let className = 'u-btn-blue m-2';
                let statusName = call.call_actions&&call.call_actions.length&&call.call_actions[0].status&&call.call_actions[0].status.name?call.call_actions[0].status.name:'';
                if(statusName=='Declined'||statusName=='Call Out'){
                    className = 'u-btn-red m-2';
                }
                if(statusName=='Passed'||statusName=='Timed Out') {
                    className = 'u-btn-yellow1 m-2';
                }
                return className;
            },          // <a href="javascript: void(0)" class="c-tag-btn u-btn-blue">

            getClassNameForCallActionTypes2(action){
                let className = 'u-btn-blue m-2';
                let statusName = action.action_log&&action.action_log.status&&action.action_log.status.name?action.action_log.status.name:'';
                if(statusName=='Declined'||statusName=='Call Out'||statusName=='Sent Home'){
                    className = 'u-btn-red m-2';
                }
                if(statusName=='Passed'||statusName=='Timed Out'||statusName=='No-show') {
                    className = 'u-btn-yellow1 m-2';
                }
                return className;
            },


            /**
             * #1794 — the 2x Dip border marks a SECOND EVENT that day, not a second call.
             *
             * ed: "the 2x Dip border should only apply when you are considered for a
             * second event on that same day." Two calls on ONE job across a day are one
             * event — a load-in and a later call — and must NOT get the border. A
             * different job the same day is a second event and does.
             *
             * Same-day stays NECESSARY; different-job is an ADDITIONAL condition, not a
             * replacement. `adjJobId` is the adjacent call's job, newly carried through
             * the payload as prev_Call_job_id / next_Call_job_id — before this it did
             * not exist anywhere on the wire, which is why the border could not tell
             * one event from two.
             *
             * ABSENT job id -> NO border. A missing id means we cannot prove a second
             * EVENT, and a false positive is exactly what ed reported; staying silent is
             * the safe direction. It also means an older payload degrades to no border
             * rather than to a wrong one.
             */
            checkPrevNextCallSameDay(dateTime, adjJobId) {
                let prevDate = moment(dateTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
                let callStartDate = '';
                let callEndDate = '';
                // if(this.$route.name == 'bulkAssignCustom') {
                //     callStartDate = moment(this.bulkCallStartTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
                //     callEndDate = moment(this.bulkCallEndTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
                // }else {
                //     callStartDate = moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
                //     callEndDate = moment(this.callEndTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
                // }
                if(prevDate==callStartDate||prevDate==callEndDate) {
                    // SECOND EVENT ONLY. Same job across the day is one event.
                    var viewedJobId = this.viewedJobId();
                    if (!adjJobId || !viewedJobId) {
                        return false;
                    }
                    return String(adjJobId) !== String(viewedJobId);
                }
                return false;
            },
            /**
             * #1794 — the job currently being assigned. The route carries it
             * base64-encoded, which is the same source isCurrentJobHTS already uses,
             * so the two cannot disagree about which job "this job" is.
             */
            viewedJobId() {
                try {
                    return atob(this.$route.params.id);
                } catch (e) {
                    return null;
                }
            },
            getClientContactFormat(phone) {
                phone = phone && phone!='' ? phone.toString() : '';
                phone = phone.replace(/-/g, "");
                phone = phone.replace(/ /g, "");
                phone = phone.replace("(", "");
                phone = phone.replace(")", "");
                let result = '';
                if(phone&&phone.length==10) {
                    // console.log(phone);
                    result = '+1'+phone;
                }else if(phone&&phone.length==11) {
                    // console.log(phone);
                    result = '+' + phone;
                }else if(phone&&phone.length) {
                    result = phone;
                }
                return result;
                // return phone;
            },
            getRoundOffSkillSeniority(seniorityVal) {
                // console.log(seniorityVal);
                if(seniorityVal && seniorityVal != '') {
                    if(seniorityVal.valueOf() == parseInt(seniorityVal)){
                        let x = parseInt(seniorityVal);
                        return x;
                    }
                }
                return seniorityVal;
            },
            async openDeclinedModal(emp) {
                // console.log('This call Declined');
                // console.log(emp);
                // console.log(this.isSteward);
                if((this.userRoleSlug != 'employee') || (this.userRoleSlug == 'employee' && this.isSteward)) {
                    await this.$confirm('Do you want to Un-Decline', 'Un-Decline?', {
                    confirmButtonText: 'Undecline',
                    cancelButtonText: 'Cancel',
                    }).then(async () => {
                        await this.undeclinedCall(emp);
                    }).catch(() => {});
                }
            },

            async undeclinedCall(emp) {
                // console.log(emp);

                await service.post('call/undecline', {
                    'employee_id': emp.id,
                    'call_id': this.getDeclinedCallId(emp.call_actions),
                    'user_id': this.userID
                }, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                }).
                then((res) => {
                    let action = 'Decline'
                    // console.log(res)
                    this.$Progress.finish();
                    this.$notify({
                        title: 'Success',
                        message: 'Call undeclined successfully.',
                        type: 'success'
                    });
                    bus.$emit('callUnDecline', action );
                }).catch((err) => {
                    console.log(err);
                    this.$notify({
                        title: 'Warning',
                        message: 'Call undeclined Failed.',
                        type: 'warning'
                    });
                    this.$Progress.finish();
                });
            },

            getDeclinedCallId(data) {
                let call_id = data[0].call_id;
                if(data.length > 1) {
                    for(let i=0; i<data.length; i++) {
                        if(data[i].action_name == "Declined") {
                            call_id = data[i].call_id
                        }
                    }
                }
                // console.log(call_id);
                return call_id;
            },

            isCurrentJobHTS(hts_list){
                if(hts_list && !Array.isArray(hts_list)){
                    hts_list=Object.values(hts_list)
                }
                let flag=false;
                hts_list.forEach(hts => {
                    // console.log(hts.job_id, atob(this.$route.params.id));
                    if(hts.job_id == atob(this.$route.params.id)){
                        flag=true;
                    }
                });
                return flag;
            },
            getJobTitle(hts_list){
                if(hts_list && !Array.isArray(hts_list)){
                    hts_list=Object.values(hts_list)
                }
                // console.log('hts_list',hts_list);
                return (hts_list && hts_list.length? hts_list[0].job_name :'');
            },
            getCallActionByType(call_action, type){
                let declines = [], passes = [], timeouts = [], callouts = [];
                if(call_action && call_action.length){
                    call_action.forEach(call => {
                        switch(call.action_name){
                            // decline Call
                            case 'Declined':
                                declines.push(call);
                            break;
                            // call out
                            case 'Call Out':
                                callouts.push(call);
                            break;
                            // Call time out
                            case 'Timed Out':
                                timeouts.push(call);
                            break;
                            // pass call
                            case 'Passed':
                                passes.push(call);
                            break;

                            default:
                                // console.log('call Action not found switch 1')
                        }
                    });
                }
                switch(type){
                    // decline Call
                    case 'Declined':
                        return declines;
                    break;
                    // call out
                    case 'Call Out':
                        return callouts;
                    break;
                    // Call time out
                    case 'Timed Out':
                        return timeouts;
                    break;
                    // pass call
                    case 'Passed':
                        return passes;
                    break;

                    default:
                        // console.log('call Action not found switch 2')
                }
                return [];
            },
            checkThisClickCooking(bookings,conflicts){
                if(conflicts) {
                    // console.log(conflicts);
                }
                // console.log(bookings[0].client_id);
                // console.log(this.userClientID);
               if(bookings.length>0 && bookings[0].client_id == this.userClientID){
                    return true;
                }
                return false;
                //  if(bookings.length == 0 && conflicts.length > 0 && conflicts[0]){
                //     return false;
                // }
                // return true;
            },

            checkAssignedJob(employee) {
                let bookings = employee.bookings;
                if(bookings.length>0 && bookings[0].client_id == this.userClientID &&  bookings[0].job_id == atob(this.$route.params.id)){
                    return true;
                }
                return false;
            },

            getParticipation(data){
                var result = 0;
                //console.log('Data',data);
                if(data != null && data != '')
                    result = Math.round(Number(data).toFixed(2) * 100) / 100;
                return result;
            },

            getParticipationJulyJune(data){
                var result = 0;
                //console.log('Data',data);
                if(data != null && data != '')
                    // console.log(data);
                    result = Math.round(Number(data).toFixed(2) * 100) / 100;
                return result;
            },

            getDeclineStatus(call_actions){
                let data = this.getCallActionByType(call_actions, "Declined");
                if((data.length>0 || Object.keys(data).length>0)){
                    return true;
                }
                return false;
            },

            getTimeStampValue(data){
                //console.log('getTimeStampValue',data)
                if(data)  return dateTimeConvert.utcTimeToUserTime(data);
                return '- - -';
            },

            getTimeStamp(data){
                //console.log('getTimeStampValue',data)
                if(data)  return moment(data).format('MM/DD/YYYYY @HH:mm:ss');
                return '- - -';
            },

            getGloabalDateTimeFormat(data) {
                return dateTimeConvert.globalDateTime2(data,this.userDateFormat,this.userTimeFormat);
            },

            getPassStatus(call_actions){
                let data = this.getCallActionByType(call_actions, "Passed");
                // console.log(data);
                // console.log(Object.keys(data).length);
                if ((data.length > 0 || Object.keys(data).length>0)) {
                    return true;
                }
                return false;
            },

            getTimeOutStatus(call_actions){
                let data = this.getCallActionByType(call_actions, "Timed Out");
                if ((data.length > 0 || Object.keys(data).length>0)) {
                    return true;
                }
                return false;
            },

            getCallOutStatus(call_actions){
                let data = this.getCallActionByType(call_actions, "Call Out");
                // console.log(data);
                // console.log(Object.keys(data).length);
                if ((data.length > 0 || Object.keys(data).length>0)) {
                    return true;
                }
                return false;
            },

            getCustomField(data) {
                // var customFld = JSON.parse(data);
                // return customFld.value;
                var customFld = JSON.parse(data);
                let re = -1;
                let re2 = -1;
                if(customFld && customFld.value)
                {
                    re = customFld.value.search('{\"name\":');
                    let inner = "";
                    if(re>=0) {
                        inner = JSON.parse(customFld.value);
                        // console.log(inner);
                        if(inner&&inner != ''&&inner.value)
                            re2 = customFld.value.search('{\"name\":')
                        if(inner.value == "{}" || inner.value == "NULL" || inner.value == "null" || inner.value == "Null" || re2>=0)
                            return '';
                        return inner.value;
                    }else
                    return customFld&&customFld.value&& customFld.value !='{}' && customFld.value !='NULL' && customFld.value!='Null' && customFld.value != 'null' ? customFld.value : '';
                }
                return "";
            },

            employeeSummary() {
                this.$modal.show('employeeSummary');
            },

            hideModal() {
                this.$modal.hide();
            },

            getTime(dateTime) {
                return dateTimeConvert.localTime(dateTime);
            },

            getConflictDate(dateTime) {
                return dateTimeConvert.localDate(dateTime, 'DD MMM');
            },

            getCallTime(time) {
                let result = time;

                result = moment(time,'YYYY-MM-DD HH:mm:ss').format('HH:mm');

                return result;
            },

            // getTurnOverNext(dateTime, turnover){
            //     var startDate = moment(dateTime, "YYYY-MM-DD HH:mm:ss");
            //     var endDate = moment(this.callStartTime, "YYYY-MM-DD HH:mm:ss");// another date
            //     var duration = moment.duration(startDate.diff(endDate));
            //     var result = duration.asMinutes();
            //     result=(result>0)?result:result*-1;
            //     // return result/60;
            //     if(result>Number(turnover)*60)
            //         return false;
            //     else
            //         return true;
            // },
            // getTurnOverPrev(dateTime, turnover){
            //     var startDate = moment(this.callEndTime, "YYYY-MM-DD HH:mm:ss");
            //     var endDate = moment(dateTime, "YYYY-MM-DD HH:mm:ss");
            //     var duration = moment.duration(startDate.diff(endDate));
            //     var result = duration.asMinutes();
            //     result=(result>0)?result:result*-1;
            //     // return result/60;
            //     if(result>Number(turnover)*60)
            //         return false;
            //     else
            //         return true;
            // },

            checkTurnOver(calls){
                if(calls && Object.keys(calls).length){
                    let duration = calls[0].call_interval.split(':');
                    if(duration.length>=2 && Number(duration[0]) <= 24){
                        let hours =  Number(duration[0]);
                        if(hours < this.turnoverTime){
                            return true;
                        }
                    }
                }
                return false;
            },

            getPrevCallTime(calls) {
                if(calls && Object.keys(calls).length){
                    let duration = calls[0].call_interval.split(':');
                    if(duration.length >= 3 && Number(duration[0]) < 24){
                        return 'Last call '+moment(calls[0].call_interval, 'HH:mm:ss').format('HH:mm')+'+';
                    }
                }
                return "Last call 24:00+";
            },
            getPrevCallDateTime(dateTime) {
                let result = "24:00+"
                if(dateTime&&dateTime!='') {
                    result = this.getGloabalDateTimeFormat(dateTime)
                }
                return result;
            },
            getNextCallDateTime(dateTime) {
                let result = "24:00+"
                if(dateTime&&dateTime!='') {
                    result = this.getGloabalDateTimeFormat(dateTime)
                }
                return result;
            },
            getNextVacationAndCallTime(vacation,calls) {
                let result1 = '';
                let result2 = '';
                if(calls && Object.keys(calls).length){
                    let duration = calls[0].call_interval.split(':');
                    if(duration.length >= 3 && Number(duration[0]) < 24){
                        result1 =  'Next call '+moment(calls[0].call_interval, 'HH:mm:ss').format('HH:mm')+'+';
                    }
                }
                if(vacation && Object.keys(vacation).length){
                    let duration = vacation[0].vacation_interval.split(':');
                    if(duration.length >= 3 && Number(duration[0]) < 24){
                        result2 = 'Next vacation: '+moment(vacation[0].vacation_interval, 'HH:mm:ss').format('HH:mm')+'+';
                    }
                }
                return result1 + ', ' + result2;
            },

            getNextVacationTime(calls) {
                if(calls && Object.keys(calls).length){
                    let duration = calls[0].vacation_interval.split(':');
                    if(duration.length >= 3 && Number(duration[0]) < 24){
                        return 'Next vacation '+moment(calls[0].vacation_interval, 'HH:mm:ss').format('HH:mm')+'+';
                    }
                }
                return "Next call 24:00+";
            },
            getNextCallTime(calls) {
                if(calls && Object.keys(calls).length){
                    let duration = calls[0].call_interval.split(':');
                    if(duration.length >= 3 && Number(duration[0]) < 24){
                        return 'Next call '+moment(calls[0].call_interval, 'HH:mm:ss').format('HH:mm')+'+';
                    }
                }
                return "Next call 24:00+";
            },

            renderVacations(vacations) {
                let resultValue = ''; // final return value string.
                vacations.forEach(obj => {
                    // let isSameDay = this.date.split(' ', 1)[0] == obj.start.split(' ', 1)[0] && obj.start.split(' ', 1)[0] == obj.end.split(' ', 1)[0];
                    // if(isSameDay) {
                    //     resultValue += moment(obj.start,'YYYY-MM-DD HH:mm:ss').format('hh:mm A') + ' - ' + moment(obj.end,'YYYY-MM-DD HH:mm:ss').format('hh:mm A') + ' - '+ obj.label + ', ';
                    // }else if(obj.start.split(' ', 1)[0] == obj.end.split(' ', 1)[0]) {
                    //     resultValue += moment(obj.start,'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY hh:mm A') + ' - ' + moment(obj.end,'YYYY-MM-DD HH:mm:ss').format('hh:mm A') + ' - '+ obj.label + ', ';
                    // }else {
                    resultValue += moment(obj.start,'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY hh:mm A') + ' - ' + moment(obj.end,'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY hh:mm A') + ' - '+ obj.label + ', ';
                    // }
                })
                // for(let key=0;key<vacations.length;key++) {
                //     resultValue += vacations[key].start + '-' + vacations[key].end + ', '
                // }
                if(resultValue!=''){
                    resultValue = `<div class="mb-1 c-tag-btn u-btn-red"> Vacations: ${resultValue} </div>`;
                }
                return resultValue;
            },

            renderUnavailability(unavailability_list) {
                let resultValue = ''; // final return value string.
                let unavailable_obj = JSON.parse(unavailability_list)
                let weekDaysNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
                let selectedDateDay = moment(this.date,'YYYY-MM-DD').format('dddd');
                let dayIndex = (parseInt(weekDaysNames.indexOf(selectedDateDay))+1).toString();
                let arrayKeys = Object.keys(unavailable_obj[dayIndex]);
                let valueArray = unavailable_obj[dayIndex]
                for(let key=0;key<arrayKeys.length;key++) {
                    let resultArray = valueArray[arrayKeys[key]];
                    resultValue += resultArray[0] + '-' + resultArray[1] + ', '
                }
                if(resultValue!=''){
                    resultValue = `<div class="mb-1 c-tag-btn u-btn-red"> Unavailable: ${resultValue} </div>`
                } else {
                    this.noRecurring = true;
                }
                return resultValue;
            },

            checkAvailability(employee) {
                let result = true;
                if(employee.employable&&employee.employable.vacations&&employee.employable.vacations.length){
                    result = false;
                }
                if(employee.calls&&employee.calls.length) {
                    result = false;
                }
                if(employee.call_actions&&employee.call_actions.length) {
                    result = false;
                }
                if((employee.employable&&employee.employable.availibility)&&!this.noRecurring){
                    result = false;
                }
                return result;
            },

            getCallActionNote(note) {
                let result = note;
                // let str = "Welcome to GeeksforGeeks.";
                let check = note.includes("Callout: ");
                if(check) {
                    result = note.replace('Callout: ','');
                    return result;
                }
                check = note.includes("Decline: ");
                if(check) {
                    result = note.replace('Decline: ','');
                    return result;
                }
                check = note.includes("Sent Home: ");
                if(check) {
                    result = note.replace('Sent Home: ','');
                    // result = note;
                    return result;
                }
                return result;
            },

            checkVacationWithinCall(vacations) {
                if(vacations.length>0){
                    return true;
                }else{
                    return false;
                }
            },
        },
        created() {
            // console.log(this.callStartTime,this.callEndTime);
            // console.log(this.$route.name);
            switch(this.columnLabel){
                case "skill_seniority":
                    this.columnClass='calls-table-cell tcell_5'
                    break;
                case "shift_count_total":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "shift_count_ytd":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "declines_total":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "declines_ytd":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "declines_ytd_july_june":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "shifts_this_week":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "employee_cell_phone":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "employee_name":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "conflicts":
                    this.columnClass='calls-table-cell tcell_7'
                    break;
                case "shifts_ytd_july_june":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "location":
                    this.columnClass='calls-table-cell tcell_5'
                    break;
                case "decline_this_week":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "participation":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "participation_july_june_desc":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "last_offer":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "wishlist":
                    this.columnClass='calls-table-cell tcell_3'
                    break;
                case "employee_seniority":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "custom_field1":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "custom_field2":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
            }
            this.turnoverTime = this.client.turnover;
            // this.selectedSortType = this.client.default_sort;
            this.customField1 = this.client.custom_field_1;
            this.customField2 = this.client.custom_field_2;
            this.showCustom = this.client.call_assignment_title;
            this.callAssigmentSettings = this.client.settings['call-assignment-config'];
        }
    }

</script>
<style scoped>
.m-2 {
    margin: 1px!important;
}
.mb-1{
    margin-bottom: 100px!important;
}
.phone-number-display{
    padding: 5px;
    cursor: pointer;
    color: #222222;
    text-decoration: none !important;
}
.u-btn-blue {
    background: #37bae8!important;
}

.u-btn-yellow1 {
    background: #e8e000bf!important;
}
.u-btn-border-red {
    border: solid 5px red;
}
.o-half-div-width{
    width: auto;
}
.text-dark {
    color: #000000!important;
}
</style>../../../timeConvert&Compare.js../../../main.js
